import React, { useState } from "react";
import "../styles/Productdetailed.css";
import TestimonialSlider from "../Page-section/Home/TestimonialSlider";
import Productsections from "../Page-section/Home/Productsections";
import Ingredients from "../Page-section/Home/stamina-ingredients";
import CertificationSection from "../Page-section/Home/certification";
import StaminaConsumeSection from "../consume-banner/StaminaConsumeSection";

import icon1 from "../assets/images/icon1.svg";
import icon2 from "../assets/images/icon2.svg";
import icon3 from "../assets/images/icon3.svg";
import icon4 from "../assets/images/icon4.svg";
import productImg from "../assets/images/stamina.png";
import productImg2 from "../assets/images/stamina-02.png";

const Stamina = () => {
  const [activeImage, setActiveImage] = useState(productImg);

  const product = {
    name: "STAMINA | Ayurvedic Calcium and Iron Supplement",
    price: 999,
    oldPrice: 1499,
    images: [productImg, productImg2],
    description:
      "STAMINA is a premium Ayurvedic Calcium and Iron Supplement designed to support healthy bone health and boost energy levels. This natural wellness solution enhances hemoglobin levels and promotes overall vitality with regular use. A perfect blend of traditional herbs and essential minerals for complete wellness.",
    // buyLink: "https://0frb0r-9m.myshopify.com/products/stamina",
  };

  return (
    <>
      <section className="product-details">
        <div className="product-details-wrapper">
          <div className="product-image">
            <div className="main-image">
              <img src={activeImage} alt={product.name} />
            </div>
            <div className="thumbnail-row">
              {product.images.slice(0, 3).map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt="thumb"
                  className={`thumbnail ${activeImage === img ? "active" : ""}`}
                  onClick={() => setActiveImage(img)}
                />
              ))}
            </div>
          </div>
          <div className="product-content">
            <h1>{product.name}</h1>

            <div className="rating">
              <span className="stars">★★★★★</span>
              <span className="reviews">(156)</span>
            </div>

            <p className="description">{product.description}</p>

            <div className="features">
              <div className="feature">
                <img src={icon1} alt="Bone Health" />
                <span>Supports Healthy Bone Health*</span>
              </div>
              <div className="feature">
                <img src={icon2} alt="Energy" />
                <span>Boosts Energy Levels*</span>
              </div>
              <div className="feature">
                <img src={icon3} alt="Hemoglobin" />
                <span>Increases Hemoglobin Levels*</span>
              </div>
              <div className="feature">
                <img src={icon4} alt="Ayurvedic" />
                <span>Natural Ayurvedic Formula*</span>
              </div>
            </div>

            <div className="price-row">
              <span className="new-pricee">Rs. {product.price}</span>
              <span className="old-pricee">Rs. {product.oldPrice}</span>
            </div>

            <hr />

            <div className="action-buttons">
              <button className="buy-btn" onClick={() => window.open(product.buyLink, '_blank')}>BUY IT NOW</button>
            </div>
          </div>
        </div>

        <a
          href="https://wa.me/919211710043"
          target="_blank"
          rel="noreferrer"
          className="whatsapp"
        >
          <i className="fab fa-whatsapp"></i>
        </a>
      </section>
      <Ingredients />
      <StaminaConsumeSection />
      <CertificationSection />
      <TestimonialSlider />
      <Productsections />
    </>
  );
};

export default Stamina;
